// @flow
import React from 'react';
import cn from 'classnames';

import styles from './DisplayExchange.module.scss';;


type Props = {
  className: string,
  changes: Array<{
    id: string,
    from: string,
    to: string,
  }>
}

const DisplayExchange = ({ className, changes }: Props) => {
  return (
    <ul className={cn(styles.root, className)}>
      {changes.map(({ id, from, to }) => (
        <li key={id}>
          {`${from} → ${to}`}
        </li>
      ))}
    </ul>
  );
};

export default DisplayExchange;
